import React, { useEffect, useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../helpers/form/FormHelper'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import MyButton from '../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../helpers/form/FormData'
import SupplyOrderDescriptionField from './fields/SupplyOrderDescriptionField'
import SupplyOrderFormItems from './items/SupplyOrderFormItems'
import { addSupplyOrderAPI } from '../../../../api/supply/supplyOrderAPI'
import DepartmentSelectMain from '../../../form/fields/DepartmentSelectMain'
import { useDispatch } from 'react-redux'
import { addSupplyOrder } from '../../../../store/supplyOrderSlice'
import DepartmentTypeSelectMain from '../../../form/fields/DepartmentTypeSelectMain'

const SupplyOrderForm = ({ supplyOrderBd, setOpen }) => {

    const dispatch = useDispatch()

  	const [data, setData] = useState(supplyOrderBd ? supplyOrderBd : {}) // Дані з форми

	// Весь обʼєкт обраного підрозділу. Потрібен, щоб знати чи опис заявки обовʼязковий саме для нього
	const [department, setDepartment] = useState(null)

	// Для частини підрозділів (КБ відділи) опис обовʼязковий. Вмикається галочкою в адмінці
	const isDescriptionRequired =
		formDataProductRequiredField('description', 'supplyOrder') ||
		(department && department.isDescriptionRequired === true) ? true : false

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addSupplyOrderAPI(dataForBd).then(data => {
            dispatch(addSupplyOrder(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        // editSupplierAPI(dataForBd).then(data => {
        //     setOpen(false)
        //     setLoading(false)
        // }).catch(e => {
        //     setError(responseError(e))
        //     setLoading(false)
        // })
    }

    const setDataForBd = () => {
        let dataForBd = {
            departmentTypeId: data.departmentTypeId,
            departmentId: data.departmentId,
            description: data.description,
            items: data.items,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('departmentTypeId', 'supplyOrder') ?
				<DepartmentTypeSelectMain
					required={formDataProductRequiredField('departmentTypeId', 'supplyOrder')}
					setValidate={e => updateValidate(setValid, 'departmentTypeId', e)}
					setValueForm={e => setValueForm(setData, 'departmentTypeId', e)}
					forciblyValue={data && data.departmentTypeId ? data.departmentTypeId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('departmentId', 'supplyOrder') ?
				<DepartmentSelectMain
                    departmentTypeId={data.departmentTypeId}
					required={formDataProductRequiredField('departmentId', 'supplyOrder')}
					setValidate={e => updateValidate(setValid, 'departmentId', e)}
					setValueForm={e => setValueForm(setData, 'departmentId', e)}
					setValueObjectForm={e => setDepartment(e)}
					forciblyValue={data && data.departmentId ? data.departmentId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('description', 'supplyOrder') ?
				<SupplyOrderDescriptionField
					required={isDescriptionRequired}
					setValidate={e => updateValidate(setValid, 'description', e)}
					setValueForm={e => setValueForm(setData, 'description', e)}
					forciblyValue={data && data.description ? data.description : ''}
				/>
			: ''
        }

        <p className='supplyOrder__header'>
            Позиції
        </p>

        {
			formDataProductIsField('items', 'supplyOrder') ?
				<SupplyOrderFormItems
                    // supplyOrderItems={supplyOrderItems}
                    // supplyOrderItems={data.items}
					required={formDataProductRequiredField('items', 'supplyOrder')}
					setValidate={e => updateValidate(setValid, 'items', e)}
					setValueForm={e => setValueForm(setData, 'items', e)}
					forciblyValue={data && data.items ? data.items : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplyOrderForm